module.exports = __webpack_public_path__ + "static/media/img1.4f9c3d9b.jpg";